import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Icon } from '../../../shared/ui';
import { IconMap } from '../../../shared/sprite';
import {
  SETTINGS_INTEGRATIONS_ROUTE,
  SETTINGS_PROFILE_ROUTE,
  SETTINGS_SUPERUSER_ROUTE,
} from '../../../entities/history';

import { matchPath, useLocation } from 'react-router-dom';
import { redirectActions } from '../../../entities/history';
import { navigate } from '../../../processes/navigation';
import { authUserModel } from '../../../entities/auth-user';
import { useTeamPermissions } from '../../../features/teams';
import { WorkspaceNavigationItem } from './WorkspaceNavigationItem';
import { Item } from './types';

export const SettingsNavigation: FC = () => {
  const location = useLocation();

  const dispatch = useDispatch();

  const currentUser = useSelector(authUserModel.selectors.selectUserWithError);

  const { isGuest } = useTeamPermissions();

  const navigationInfo: (Item & { route: string })[] = [
    {
      id: 'profile',
      label: 'Profile',
      icon: IconMap.User,
      route: SETTINGS_PROFILE_ROUTE,
    },
    {
      id: 'integrations',
      label: 'Integrations',
      icon: IconMap.PuzzlePiece01,
      route: SETTINGS_INTEGRATIONS_ROUTE,
      isHidden: isGuest,
    },
    {
      id: 'superuser',
      label: 'Superuser Panel',
      icon: IconMap.Users,
      route: SETTINGS_SUPERUSER_ROUTE,
      isHidden: !currentUser.isAdmin,
    },
  ].filter((item) => !item.isHidden);

  const currentRouteId = navigationInfo.find((item) =>
    matchPath(location.pathname, { path: item.route })
  )?.id;

  return (
    <>
      <Button
        color="link-gray"
        variant="icon-text"
        size="sm"
        onClick={() => {
          dispatch(redirectActions.toWorkspaceByBackUrl());
        }}
        className="!h-9 !px-3 !font-semibold md:hidden self-start mt-5"
      >
        <Icon glyph={IconMap.BackArrow} className="mr-2" />
        Back
      </Button>
      <div className="pl-3 text-lg font-bold text-gray-900">Settings</div>
      <div className="flex flex-col">
        {navigationInfo.map((item) => (
          <WorkspaceNavigationItem
            key={item.id}
            label={item.label}
            icon={item.icon}
            onClick={() =>
              dispatch(navigate({ to: item.route, isKeepQueryParams: true }))
            }
            isActive={item.id === currentRouteId}
          />
        ))}
      </div>
    </>
  );
};
